import { AppointmentEventSlotData } from '../../AppointmentsTimetable.types';

export const getPatientName = (appointment: AppointmentEventSlotData): string => {
   const { patient } = appointment;
   if (patient.lastName && patient.firstName) {
      return `${patient.lastName} ${patient.firstName}`;
   }
   return patient.lastName?.asString() || patient.firstName?.asString() || patient.phoneNumber?.asString() || '';
};
